import styled, { css } from 'styled-components';
import { Icon as IconComponent } from 'src/components';

export const Header = styled.div(
  ({ theme }) => css`
    gap: ${theme.sz.s3};
    display: flex;
    svg {
      height: ${theme.sz.s6};
      width: ${theme.sz.s6};
    }
  `,
);

export const CardButton = styled.button(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: none; // resets default style
    border: 0; // resets default style
    padding: 0; // resets default style
    color: inherit;
    cursor: pointer;
    text-align: left;
    ${theme.typography.heading.desktop.xxs};
  `,
);

export const CardDescription = styled.div<{
  $collapsed: boolean;
}>(
  ({ $collapsed, theme }) => css`
    display: ${$collapsed ? 'none' : 'block'};
    background-color: ${theme.co.neutral99};

    margin: ${theme.sz.s2} -${theme.sz.s2} -${theme.sz.s2} -${theme.sz.s2};
    padding: ${theme.sz.s2};
  `,
);

export const CardElement = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    margin: ${theme.sz.s2} 0;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
      margin: ${theme.sz.s1} 0;
    }
  `,
);

export const CollapsibleCard = styled.div<{ $isOfficial: boolean }>(
  ({ theme, $isOfficial }) => css`
    width: 100%;
    background-color: ${theme.co.neutral99};
    border: ${theme.bo.thinWidth} solid ${theme.co.secondary90};
    color: ${theme.co.neutral20};
    cursor: pointer;
    overflow: hidden;
    white-space: break-spaces;
    max-width: ${theme.sz.s};

    padding: ${theme.sz.s2};
    border-radius: ${theme.bo.mediumSmall};
    background: ${$isOfficial ? theme.co.information90 : theme.co.tertiary90};
  `,
);

export const Icon = styled(IconComponent)<{ $collapsed?: boolean }>(
  ({ $collapsed, theme }) => css`
    font-size: ${theme.sz.s6};
    line-height: ${theme.sz.s5};
    transform: rotate(${$collapsed ? '0deg' : '180deg'});
  `,
);
